export default "__VITE_ASSET__DU3wr4ql__"